import React, { Suspense, lazy } from 'react';
import { Link } from 'react-router-dom';
import { HyperText } from '../components/HyperText';
import { WordFadeIn } from '../components/ui/WordFadeIn';
import { motion } from 'framer-motion';
// Lazy load the WhatWeDoFeature component
const WhatWeDoFeature = lazy(() => import('../components/WhatWeDoFeature'));
const HomePage = () => {
  return <div className="w-full" data-id="element-346">
      <div className="w-full relative min-h-screen" data-id="element-347">
        <div className="absolute inset-0 w-full h-full overflow-hidden" data-id="element-348">
          <div className="absolute inset-0 bg-blue-900/30 mix-blend-overlay z-10" data-id="element-349"></div>
          <iframe src="https://player.vimeo.com/video/1081174959?badge=0&autopause=0&player_id=0&app_id=58479&background=1&autoplay=1&loop=1&muted=1" className="absolute w-[400%] sm:w-[200%] md:w-full h-full -left-[150%] sm:-left-[50%] md:left-0 top-0 object-cover" style={{
          pointerEvents: 'none',
          transform: 'scale(1.5)',
          transformOrigin: 'center center'
        }} loading="lazy" fetchpriority="high" importance="high" title="Background Video" allow="autoplay; fullscreen; picture-in-picture" data-id="element-350"></iframe>
        </div>
        <div className="relative z-20 flex flex-col justify-end h-screen pb-16 px-4 sm:px-6" data-id="element-351">
          <div className="max-w-7xl mx-auto w-full opacity-0 animate-[fadeIn_0.5s_ease-in_0.3s_forwards]" data-id="element-352">
            <div className="max-w-lg" data-id="element-353">
              <WordFadeIn words="Your Partner in Healthcare Excellence" className="text-2xl sm:text-3xl md:text-4xl font-light text-white mb-4 font-display leading-tight tracking-normal" delay={0.3} data-id="element-354" />
              <WordFadeIn words="We are a leading, innovative healthcare company dedicated to driving operational excellence and scalable growth in the hospice sector." className="text-sm sm:text-base md:text-lg text-white mb-6 leading-relaxed font-light" delay={0.4} variants={{
              hidden: {
                opacity: 0,
                y: 10
              },
              visible: (i: number) => ({
                y: 0,
                opacity: 1,
                transition: {
                  delay: 0.4 + i * 0.02,
                  duration: 0.2
                }
              })
            }} data-id="element-355" />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-center bg-cover bg-no-repeat py-12 sm:py-16 md:py-24" style={{
      backgroundImage: `url(https://uploadthingy.s3.us-west-1.amazonaws.com/gcpk1LX8p6GmwLWQvMQvMc/navy.png)`
    }} data-id="element-356">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-357">
          <div className="text-center mb-10 sm:mb-16" data-id="element-358">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-white mb-8 sm:mb-12 tracking-normal" data-id="element-359">
              What We Do
            </h2>
            {/* Suspense boundary for lazy-loaded component */}
            <Suspense fallback={<div className="h-[350px] flex items-center justify-center" data-id="element-361">
                  <div className="animate-pulse text-white" data-id="element-362">Loading...</div>
                </div>} data-id="element-360">
              <div className="flex justify-center mb-8 sm:mb-16 overflow-hidden" data-id="element-363">
                <WhatWeDoFeature badgeTexts={{
                first: 'Partner',
                second: 'Consolidate',
                third: 'Integrate'
              }} buttonTexts={{
                first: 'Excellence',
                second: 'Innovation'
              }} title="Comprehensive Healthcare Solutions" circleText="Why" description="To provide compassionate, personalized care by empowering providers through innovation and integrity." lightColor="#2563eb" data-id="element-364" />
              </div>
            </Suspense>
          </div>
          <div className="max-w-2xl mx-auto bg-gray-900/50 p-4 sm:p-6 rounded-2xl border border-[#89CFF0] text-white transition-all duration-300 hover:shadow-[0_0_15px_5px_rgba(137,207,240,0.3)] mt-20 sm:mt-32" data-id="element-365">
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6" data-id="element-366">
              <div className="flex-shrink-0" data-id="element-367">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hpNg8pWML54HCyBvmiLF99/Robert_Thongsavanh.jpg" alt="Robert Thongsavanh" className="w-16 h-16 sm:w-20 sm:h-20 object-cover object-center rounded-full border-2 border-[#89CFF0]" loading="lazy" data-id="element-368" />
              </div>
              <div data-id="element-369">
                <p className="text-gray-300 leading-relaxed font-light italic mb-4 text-sm sm:text-base" data-id="element-370">
                  "My personal WHY started when my grandfather passed away
                  because the home health nurse never showed up… We have a
                  chance to set ourselves apart within a fragmented industry by
                  "out serving" the competition and ensuring every patient is
                  met with excellence."
                </p>
                <div className="flex items-center gap-2 justify-center sm:justify-start" data-id="element-371">
                  <h3 className="text-base sm:text-lg font-light tracking-normal" data-id="element-372">
                    Robert Thongsavanh
                  </h3>
                  <span className="text-gray-400 text-xs sm:text-sm font-light" data-id="element-373">
                    • Partner and Strategic Advisor
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default HomePage;